import React, { useEffect } from 'react'; 
import { Outlet } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import { useUIStore } from '../../store/uiStore';
import ToastContainer from '../UI/ToastContainer';

const Root = () => {
  const { initDarkMode } = useUIStore();

  useEffect(() => {
    initDarkMode();
  }, [initDarkMode]);

  // Session handling for "Remember Me":
  // We keep auth in localStorage for compatibility with services.
  // If Remember Me is disabled (rememberMe === '0'), we clear auth on new tab/session.
  useEffect(() => {
    try {
      const SESSION_KEY = 'fx_session_mark';
      const hasSession = !!sessionStorage.getItem(SESSION_KEY);
      if (!hasSession) {
        sessionStorage.setItem(SESSION_KEY, String(Date.now()));
        const remember = localStorage.getItem('rememberMe');
        if (remember === '0') {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('role');
        }
      }
    } catch { }
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-900 dark:bg-dark-bg dark:text-dark-text">
      <ScrollToTop />
      <ToastContainer />
      <Outlet />
    </div>
  );
};

export default Root;


